import axios from 'axios';
import { NIT_ZIBOR } from '../constants/constant';

const baseUrl = process.env.REACT_APP_AWS_API_GATEWAY_URL;
const baseFlowUrl = process.env.REACT_APP_AWS_API_GATEWAY_URL_EXECUTE_FLOW

export const fetchClientById = (accessToken, clientId) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "client_select",
            'action': "SELECT_BY_CLIENT_ID",
            'findOne': "true",
            'variables': JSON.stringify({
                'id_client': clientId
            })
        })
    });
};

export const fetchClientByNit = (accessToken, nit, id_company) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "client_select",
            'action': "SELECT_BY_IDENTIFICATION",
            'variables': JSON.stringify({
                'identification': nit,
                'id_company': id_company
            })
        })
    });
};

export const fetchClientOfficeId = (accessToken, clientId) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "client_select",
            'action': "SELECT_BY_CLIENT_OFFICE_ID",
            'variables': JSON.stringify({
                'id_client': clientId
            })
        })
    });
};


export const deleteOffice = (accessToken, variables) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'client_alter',
            'action': 'DELETE_OFFICE',
            'variables': JSON.stringify(variables)
        })
    })
}


export const updateClient = (data, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "client_alter",
            'action': "UPDATE",
            "variables": data
        })
    });
};

export const insertDataClient = (data, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            process: "client_alter",
            action: "INSERT",
            variables: data
        })
    })
};


export const updateOffice = (accessToken, variables) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'client_alter',
            'action': 'UPDATE_OFFICE',
            'variables': JSON.stringify(variables)
        })
    })
}


export const getCompanies = (id_user_action, accessToken) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'user_select',
            'action': 'SELECTCOMPANIES_CLIENT',
            'variables': JSON.stringify({ 'id_user_action': id_user_action })
        })
    })
}

export const fetchClientsConcat = (accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            "process": "client_select",
            "action": "SELECT_CONCAT",
            "variables": `{}`
        })
    });
}

export const fetchOffices = (idClient, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            "process": "client_select",
            "action": "SELECT_OFFICES_BY_ID",
            "variables": JSON.stringify({ id_client: idClient })
        })
    });
}
// Correos del cliente (client_office.email)
export const fetchClientEmails = (idOffice, accessToken) =>
    axios({
        method: 'POST', url: baseUrl, headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            process: 'client_office_select',
            action: 'SELECT_EMAILS_BY_OFFICE',
            variables: `{"id_office": "${idOffice}"}`
        })
    });

// Correos de la última factura (electronic_documents.email_recipients)
export const fetchLastInvoiceEmails = (idCompanyReceiver, accessToken) =>
    axios({
        method: 'POST', url: baseUrl, headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            process: 'electronic_documents_select',
            action: 'SELECT_LAST_EMAIL_RECIPIENTS',
            variables: `{"id_company_receiver": "${idCompanyReceiver}"}`
        })
    });

export const fetchDianAcquirerInfo = (
    accessToken,
    { receiver_id, receiver_tax_id }
) => {
    return axios({
        method: "POST",
        url: baseFlowUrl,
        // url: 'https://r5ton9113k.execute-api.us-east-1.amazonaws.com/prod/rpa/flow/activate',
        headers: {
            Authorization: `Bearer ${accessToken}`,
            // Authorization: `Bearer ${'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Impvc2UuZGlhekB6aWJvcmRlc2Fycm9sbGFkb3Jlcy5jb20iLCJpZFVzZXIiOiI0IiwiZXhwIjoxNzkwODU3NjQ4LCJpYXQiOjE3OTA3NzEyNDh9.VsECyAMpkLQ0LaDNawQbM92a15R14acZtqf6D8eT95g'}`,
            "Content-Type": "application/json",
        },
        data: {
            id_flow: `900114098-GET_ACQUIRER`,
            supplier_id: NIT_ZIBOR,
            receiver_id: String(receiver_id),
            receiver_tax_id: String(receiver_tax_id),
        },
    });
};